/* eslint-disable */
import qs from 'qs';
import moment from 'moment';
import changeCase from 'change-object-case';
import { url, authJsonHeader, authHeader, jsonHeader, jsonAndStatus, json, navTo, snakeKeys } from './utils/util';
import fetch from 'node-fetch';


function fetchError(err) {
  return {
    type: 'FETCH_ERROR',
    error: err,
  };
}

function getError(err, options={}) {
  return {
    type: 'GET_ERROR',
    error: err,
    options: options,
  };
}

function fetchUserStart(options) {
  return {
    type: 'FETCH_USER_START',
    options,
  };
}

function fetchUserSuccess(data, options) {
  return {
    type: 'FETCH_USER_SUCCESS',
    user: data.user,
    isLoggedIn: data.isLoggedIn,
    options,
  };
}

export function fetchUser(options={}) {
  return (dispatch, getState) => {
    console.log('fetchUser -> getState', getState(), options);
    dispatch(fetchUserStart(options));
    return fetch(url('/api/me'), { headers: authHeader(getState()) })
      .then(resp => jsonAndStatus(resp))
      .then(({ status, data }) => {
        let ok = status >= 200 && status < 300;
        return { user: data, isLoggedIn: ok };
      })
      .then(
        data => dispatch(fetchUserSuccess(data, options)),
        err => dispatch(fetchError(err)),
      );
  }
}

function fetcher(startAction, successAction, apiUrl, key, { auth=true } = {}) {
  return function() {
    return (dispatch, getState) => {
      dispatch({type: startAction});
      if (typeof apiUrl === 'function') {
        apiUrl = apiUrl();
      }
      let headers = {};
      if (auth) {
        headers = authHeader(getState());
      }
      return fetch(url(apiUrl), { headers: headers })
        .then(resp => json(resp))
        .then(
          data => {
            let v = {type: successAction, key: key};
            v[key] = data.results;
            return dispatch(v)
          },
          err => dispatch(fetchError(err)),
        );
    }
  }
}

function getter(key, apiUrl, auth=true) {
  let startAction = 'GET_' + key.toUpperCase() + '_START';
  let successAction = 'GET_' + key.toUpperCase() + '_SUCCESS';
  return function(id, options={}, params={}) {
    console.log('=== GET WITH ID', id);
    return (dispatch, getState) => {
      dispatch({
        type: startAction,
        key: key,
        options,
      });
      let useUrl;
      if (id) {
        useUrl = url(apiUrl + '/' + id);
      } else {
        useUrl = url(apiUrl);
      }

      let queryString = '';
      if (params) {
        let snakeParams = snakeKeys(params);
        queryString = qs.stringify(snakeParams);
        useUrl += '?' + queryString;
      }

      return fetch(useUrl, { headers: auth ? authHeader(getState()) : jsonHeader() })
        .then(resp => json(resp))
        .then(
          data => {
            return dispatch({
              type: successAction,
              key: key,
              obj: data,
              from: id,
              options,
            });
          },
          err => dispatch(getError(err)),
        );
    }
  }
}

function lister(key, apiUrl, auth=true) {
  let startAction = 'LIST_' + key.toUpperCase() + '_START';
  let successAction = 'LIST_' + key.toUpperCase() + '_SUCCESS';
  return function(params=null, options={}) {
    let queryString = '';
    if (params) {
      let snakeParams = snakeKeys(params);
      queryString = qs.stringify(snakeParams);
    }
    return (dispatch, getState) => {
      let targetKey = options.targetKey ? options.targetKey : key;

      dispatch({
        type: startAction,
        key: targetKey,
        options: options,
      });
      return fetch(url(apiUrl + '?' + queryString), { headers: auth ? authHeader(getState()) : jsonHeader() })
        .then(resp => json(resp))
        .then(
          data => {
            return dispatch({
              type: successAction,
              key: targetKey,
              items: data.results,
              count: data.count,
              from: queryString,
              options: options,
            });
          },
          err => dispatch(getError(err, options)),
        );
    }
  }
}

function updateError(key, err) {
  return {
    type: 'UPDATE_ERROR',
    key: key,
    error: err,
  };
}

function createError(key, err) {
  return {
    type: 'CREATE_ERROR',
    key: key,
    error: err,
  };
}

function creator(key, apiUrl) {
  let startAction = 'CREATE_' + key.toUpperCase() + '_START';
  let successAction = 'CREATE_' + key.toUpperCase() + '_SUCCESS';
  return function(obj, options={}) {
    return (dispatch, getState) => {
      dispatch({
        type: startAction,
        key: key,
        options,
      });
      console.log('CREATING:', apiUrl, obj);
      return fetch(url(apiUrl), {
        method: 'POST',
        headers: authJsonHeader(getState()),
        body: JSON.stringify(changeCase.snakeKeys(obj, { recursive: true, arrayRecursive: true })),
      })
        .then(resp => jsonAndStatus(resp))
        .then(
          ({ status, data }) => {
            if (status >= 200 && status < 300) {
              return dispatch({
                type: successAction,
                key: key,
                obj: data,
                options,
              });
            } else {
              return dispatch(createError(key, data));
            }
          },
          err => {
            alert('Error while trying to create ' + key);
            return dispatch(createError(key, err));
          },
        );
    }
  }
}

function updater(key, apiUrl) {
  let startAction = 'UPDATE_' + key.toUpperCase() + '_START';
  let successAction = 'UPDATE_' + key.toUpperCase() + '_SUCCESS';
  return function(id, delta, options={}) {
    return (dispatch, getState) => {
      dispatch({
        type: startAction,
        key: key,
        options,
      });
      return fetch(url(apiUrl + '/' + id), {
        method: 'PATCH',
        headers: authJsonHeader(getState()),
        body: JSON.stringify(changeCase.snakeKeys(delta, { recursive: true, arrayRecursive: true })),
      })
        .then(resp => jsonAndStatus(resp))
        .then(
          ({ status, data }) => {
            if (status >= 200 && status < 300) {
              return dispatch({
                type: successAction,
                key: key,
                obj: data,
                options,
              });
            } else {
              return dispatch(updateError(key, data));
            }
          },
          err => {
            alert('Error while trying to update ' + key);
            return dispatch(updateError(key, err));
          },
        );
    }
  }
}

function deleter(key, apiUrl) {
  let startAction = 'DELETE_' + key.toUpperCase() + '_START';
  let successAction = 'DELETE_' + key.toUpperCase() + '_SUCCESS';
  return function(id, options={}) {
    return (dispatch, getState) => {
      dispatch({
        type: startAction,
        key: key,
        options: options,
      });
      return fetch(url(apiUrl + '/' + id), {
        method: 'DELETE',
        headers: authHeader(getState()),
      })
      .then(
        data => dispatch({
          type: successAction,
          key: key,
          id: id,
          options: options,
        }),
        err => dispatch(deleteError(key, id, err)),
      );
    }
  }
}

function poster(endpoint, key, auth=true) {
  let type = key.toUpperCase()
  return function(payload, options={}) {
    return (dispatch, getState) => {
      dispatch({
        type: 'POST_' + type + '_START',
        key: key,
        options,
      });
      return fetch(url(endpoint), {
        method: 'POST',
        headers: auth ? authJsonHeader(getState()) : jsonHeader(),
        body: JSON.stringify(changeCase.snakeKeys(payload, { recursive: true, arrayRecursive: true })),
      })
        .then(resp => jsonAndStatus(resp))
        .then(({ status, data }) => {
          if (status >= 200 && status < 300) {
            dispatch({
              type: 'POST_' + type + '_SUCCESS',
              options,
            });
            return data;
          } else {
            return dispatch({
              type: 'POST_ERROR',
              key: key,
              error: data,
            });
          }
        });
    }
  }
}


export function upload(data, options={}) {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPLOAD_START',
      options,
    });
    let body = JSON.stringify(changeCase.snakeKeys(data, { recursive: true, arrayRecursive: true }));
    return fetch(url('/api/file-upload/'), {
      method: 'POST',
      headers: authJsonHeader(getState()),
      body: body,
    })
      .then(resp => jsonAndStatus(resp))
      .then(({ status, data }) => {
        if (status >= 200 && status < 300) {
          dispatch({
            type: 'UPLOAD_SUCCESS',
            options,
          });
          return data;
        } else {
          return dispatch(createError('upload', data));
        }
      });
  }
}

export function uploadUnauth(data, options={}) {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPLOAD_START',
      options,
    });
    let body = JSON.stringify(changeCase.snakeKeys(data, { recursive: true, arrayRecursive: true }));
    return fetch(url('/api/file-upload/'), {
      method: 'POST',
      headers: jsonHeader(),
      body: body,
    })
      .then(resp => jsonAndStatus(resp))
      .then(({ status, data }) => {
        if (status >= 200 && status < 300) {
          dispatch({
            type: 'UPLOAD_SUCCESS',
            options,
          });
          return data;
        } else {
          return dispatch(createError('upload', data));
        }
      });
  }
}


/* ---- GETTERS ---- */
export const getGeoIp = getter('geoIp', '/api/geo-ip', false);
export const getProfile = getter('profile', '/api/profiles', false);
export const getCityInfo = getter('cityInfo', '/api/city-info', false);
export const getStats = getter('stats', '/api/stats', false);
export const getRoom = getter('room', '/api/rooms', false);
export const getLocation = getter('location', '/api/locations', false);
export const getSuggestions = getter('suggest', '/api/suggest', false);
export const getOmni = getter('omni', '/api/omni', false);
export const getTeam = getter('team', '/api/teams', false);
export const getLeaderboard = getter('leaderboard', '/api/leaderboard', false);
export const getRanking = getter('ranking', '/api/rank', false);
export const getCompany = getter('company', '/api/companies');
export const getFunFact = getter('funFact', '/api/fun-fact', false);
export const getDupeSuggestions = getter('dupeSuggestions', '/api/suggest-dupes');
export const getRankEscape = getter('rankEscape', '/api/rank-escape', false);
export const getBookableSlot = getter('bookableSlot', '/api/booking/bookable-slots');
export const getEscape = getter('escape', '/api/escapes');
export const getTimeSlot = getter('timeSlot', '/api/time-slots');
export const getBookingPrice = getter('bookingPrice', '/api/booking-price');
export const getNewsFeed = getter('newsFeed', '/api/news-feed');
export const getGiftCards = getter('giftCards', '/api/gift-cards');

/* ---- LISTERS ---- */
export const listLocations = lister('location', '/api/locations', false);
export const listLocationsAuth = lister('location', '/api/locations');
export const listRooms = lister('room', '/api/rooms', false);
export const listTimeSlots = lister('timeSlot', '/api/time-slots');
export const listReviews = lister('review', '/api/reviews');
export const listCompanies = lister('company', '/api/companies');
export const listThreads = lister('thread', '/api/threads');
export const listRegions = lister('region', '/api/regions');
export const listUsernames = lister('username', '/api/usernames');
export const listSchedules = lister('schedule', '/api/booking/schedules');
export const listBookableSlots = lister('bookableSlot', '/api/booking/bookable-slots');
export const listTeams = lister('team', '/api/teams', false);
export const listEscapes = lister('escape', '/api/escapes', false);

/* ---- CREATORS ---- */
export const createProduct = creator('product', '/api/products');
export const createEscape = creator('escape', '/api/escapes');
export const createTeam = creator('team', '/api/teams');
export const createReview = creator('review', '/api/reviews');
export const createRoom = creator('room', '/api/rooms');
export const createSchedule = creator('schedule', '/api/booking/schedules');
export const createWeeklySlot = creator('weeklySlot', '/api/booking/weekly-slots');

/* ---- UPDATERS ---- */
export const updateEscape = updater('escape', '/api/escapes');
export const updateTeam = updater('team', '/api/teams');
export const updateReview = updater('review', '/api/reviews');
export const updateRoom = updater('room', '/api/rooms');
export const updateLocation = updater('location', '/api/locations');
export const updateSchedule = updater('schedule', '/api/booking/schedules');
export const updateBookableSlot = updater('bookableSlot', '/api/booking/bookable-slots');
export const updateCompany = updater('company', '/api/companies');

/* ---- DELETERS ---- */
export const deleteEscape = deleter('escape', '/api/escapes');
export const deleteWeeklySlot = deleter('weeklySlot', '/api/booking/weekly-slots');
export const deleteSchedule = deleter('weeklySlot', '/api/booking/schedules');

/* ---- POSTERS ---- */
export const register = poster('/api/register', 'register', false);
export const registerFacebook = poster('/api/register-facebook', 'registerFacebook', false);
export const setAccount = poster('/api/set-account', 'setAccount');
export const login = poster('/api/auth-token', 'login', false);
export const forgotPassword = poster('/api/users/forgot', 'forgotPassword', false);
export const addEscape = poster('/api/add-escape', 'addEscape');
export const addTeam = poster('/api/add-team', 'addTeam');
export const setRank = poster('/api/set-rank', 'setRank');
export const reportMistake = poster('/api/report-mistake', 'reportMistake');
export const addComment = poster('/api/add-comment', 'addComment');
export const addLocation = poster('/api/add-location', 'addLocation');
export const importEscapes = poster('/api/import-escapes', 'importEscapes');
export const importEscapesUnauth = poster('/api/import-escapes', 'importEscapes', false);
export const excelToRows = poster('/api/excel-to-rows', 'excelToRows', false);
export const pullSheetsFromGoogle = poster('/api/pull-sheets-from-google', 'pullSheetsFromGoogle', false);
export const pullGoogleSheet = poster('/api/pull-google-sheet', 'pullGoogleSheet', false);
export const makeClaimLink = poster('/api/admin/make-claim-link', 'makeClaimLink');
export const addIntegration = poster('/api/add-integration', 'addIntegration');
export const pullMyData = poster('/api/pull-my-data', 'pullMyData');
export const addToRegion = poster('/api/add-to-region', 'addToRegion');
export const changePassword = poster('/api/change-password', 'changePassword');
export const unsubscribe = poster('/api/unsubscribe', 'unsubscribe');
export const markDupes = poster('/api/mark-dupes', 'markDupes');
export const companySignUp = poster('/api/company-sign-up', 'companySignUp', false);
export const calculatePrice = poster('/api/booking/calculate-price', 'calculatePrice', false);
export const bookChargeAuth = poster('/api/booking/book-charge-auth', 'bookChargeAuth');
export const connectStripe = poster('/api/booking/connect-stripe', 'connectStripe');
export const bookChargeIntegration = poster('/api/book-charge-integration', 'bookChargeIntegration', false);
export const emailPlayer = poster('/api/email-player', 'emailPlayer');
export const requestVerify = poster('/api/request-verify', 'requestVerify');


export function setAlreadyEscaped(roomId, value) {
  return (dispatch, getState) => {
    let existing = JSON.parse(localStorage.getItem('alreadyEscaped') || '{}');
    if (value) {
      existing[roomId] = true;
    } else if (existing[roomId] != undefined) {
      delete existing[roomId];
    }
    localStorage.setItem('alreadyEscaped', JSON.stringify(existing));
    dispatch({
      type: 'ALREADY_ESCAPED',
      obj: existing,
    });
    return new Promise((resolve, reject) => {
      resolve(existing);
    })
  }
}




/** WEBPACK FOOTER **
 ** ./src/actions.js
 **/